import { CantileverButton } from 'components/CantileverButton'
import React from 'react'

import {
  ButtonContainer,
  Dialog,
  DialogMessage,
  DialogTitle,
} from './TutorialStyledComponents'

interface WelcomeDialogProps {
  onNext: () => void
  onSkip: () => void
}

export const WelcomeDialog: React.FC<WelcomeDialogProps> = ({
  onNext,
  onSkip,
}) => {
  return (
    <Dialog>
      <DialogTitle>Welcome to Kestrel</DialogTitle>
      <DialogMessage>
        Get started with Kestrel by following our interactive tutorial!
      </DialogMessage>
      <ButtonContainer>
        <CantileverButton onClick={onSkip}>Skip Tutorial</CantileverButton>
        <CantileverButton primary onClick={onNext}>
          Next
        </CantileverButton>
      </ButtonContainer>
    </Dialog>
  )
}
